/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */


import {NgModule} from '@angular/core';
import {ScrollDispatchModule, VIEWPORT_RULER_PROVIDER} from '@angular/cdk/scrolling';
import {PlatformModule} from '@angular/cdk/platform';
import {MdCommonModule} from '../common-behaviors/common-module';
import {MdRipple} from './ripple';

export {MdRipple, RippleGlobalOptions, MD_RIPPLE_GLOBAL_OPTIONS} from './ripple';
export {RippleRef, RippleState} from './ripple-ref';
export {RippleConfig, RIPPLE_FADE_IN_DURATION, RIPPLE_FADE_OUT_DURATION} from './ripple-renderer';
export class MdRippleModule {static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
  imports: [MdCommonModule, PlatformModule, ScrollDispatchModule],
  exports: [MdRipple, MdCommonModule],
  declarations: [MdRipple],
  providers: [VIEWPORT_RULER_PROVIDER],
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function MdRippleModule_tsickle_Closure_declarations() {
/** @type {?} */
MdRippleModule.decorators;
/**
 * @nocollapse
 * @type {?}
 */
MdRippleModule.ctorParameters;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
